module.exports = __webpack_public_path__ + "assets/img/360icon.5d6246ca.svg";